export default "__VITE_ASSET__D3596kGO__"